import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

// Writes control measures for a hazard. Hosted by the same Next.js backend as the AI
// writing routes, so the Blueprint environment to verify the bearer token against is
// sent in the body. The token itself is attached by the app-wide AuthInterceptor.
//
// The sibling ControlMeasureSuggestionsService ranks library rows a consultant already
// wrote. Everything here is generated text the consultant is expected to edit before
// saving, which is why it carries no library id and no ISO 12100 category.

/** Carries no library id: there is no library row behind a generated measure, and the
 *  picker's caller saves the text rather than a reference. */
export interface GeneratedControlMeasure {
  value: string;
}

export interface GenerationContext {
  /** The assessor's written observation. The request is rejected without it. */
  hazard: string;
  hazardName?: string;
  hazardType?: string;
  hazardLocation?: string;
  hazardSources?: string;
  hazardConsequences?: string;
  machineName?: string;
  stepName?: string;
}

@Injectable({ providedIn: 'root' })
export class ControlMeasureGenerationService {
  constructor(private http: HttpClient) {}

  async forHazard(context: GenerationContext): Promise<GeneratedControlMeasure[]> {
    const res: any = await this.http
      .post(`${environment.aiWritingBaseUrl}/api/control-measures/generate`, {
        ...context,
        apiUrl: environment.tokenEndpoint,
      })
      .toPromise();
    return (res?.measures || []).map((value: string) => ({ value }));
  }
}
